var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown106 = function SvgArrowDown106(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0A",
    fillRule: "evenodd",
    d: "M.163.176a.527.527 0 0 1 .785 0L5 4.55 9.05.176a.527.527 0 0 1 .786 0 .634.634 0 0 1 0 .848l-4.444 4.8a.527.527 0 0 1-.786 0l-4.444-4.8a.634.634 0 0 1 0-.848",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown106;